import { IntegrationExportEntity } from "@nova/constants"
import { fetchApiGateway } from "@nova/fetch-api-gateway"
import useSWRMutation from "swr/mutation"

interface CalTopoExportRequest {
    workspaceId: string
    projectId: string
    entities: { type: IntegrationExportEntity; id: string }[]
}

const useExportToCalTopo = () => {
    const { trigger: exportToCalTopo, isMutating } = useSWRMutation(
        "caltopo-export",
        async (_key: string, { arg }: { arg: CalTopoExportRequest }) => {
            const res = await fetchApiGateway("post /org/:orgId/integrations/caltopo/export", {
                params: { orgId: arg.workspaceId },
                body: {
                    projectId: arg.projectId,
                    entities: arg.entities,
                },
                rawResponse: true,
            })

            if (!res.ok) throw new Error("Unable to export to CalTopo")
            return res
        }
    )

    return { exportToCalTopo, isMutating }
}

export { useExportToCalTopo }
export type { CalTopoExportRequest }
